import LineChart from "../components/Charts/lineChart";

function Dashboard({ dir }) {
    return (
        <LineChart dir={dir} />
    );
}

export default Dashboard;